import { useGetQueryBanner } from 'domains/banners/api/getBanner.hooks'

export const useQueryBanner = ({ placementId }) => {
  const { apiResult, apiSuccess, apiLoading, apiError } = useGetQueryBanner({ placementId })
  return {
    apiResult,
    apiSuccess,
    apiLoading,
    apiError,
  }
}
